import gameStore from '../../store/GameStore';
import playerStore from '../../store/PlayerStore';
import { WEvent } from './WEvent';

export class WPlayerSittingOutEvent extends WEvent {
  gameId: string;
  pid: string;
  sittingOut: boolean;

  constructor(event: WPlayerSittingOutEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  public applyWebsocketChanges = (): Promise<void> =>
    gameStore.findActiveGame(this.tableId).then(game => {
      const players = playerStore.modifyPlayers(
        game.players,
        this.pid,
        player => (player.sittingOut = this.sittingOut),
      );
      game.setPlayers(players);
    });
}
